// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.deal-modal.kv-modal .kv-modal-content.kv-modal-col-wide-2 {\n  width: 850px !important;\n}\n.deal-modal.kv-modal .kv-modal-content {\n  max-height: 95vh;\n}\n.deal-modal.kv-modal .kv-modal-content .kv-modal-body {\n  padding: 8px 15px;\n}\n.error{\n    color: red;\n    display: block;\n    padding: 5px;\n    font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
